import React, { useRef } from 'react';

import { SegmentedControl } from '@imgly/imgly-website-components';
import { uniqueId } from 'lodash';

import { CodeLanguage } from '../../../../../types';
import { getUnifiedCodeLanguage } from '../../../../../utils/getUnifiedCodeLanguage';
import { CodeBlockHeader } from '../../CodeBlockHeader';
import { CodeBlockHeaderTab } from '../../CodeBlockHeaderTabs/CodeBlockHeaderTab';

interface Props {
  title: string;
  label?: string;
  codeLanguage: CodeLanguage | string;
}

export const SimpleHeader: React.FC<Props> = ({
  title,
  label,
  codeLanguage,
}) => {
  const uuid = useRef(uniqueId('code-block-header'));
  const language = getUnifiedCodeLanguage(codeLanguage)?.name || '';

  const handleChange = () => {
    return null;
  };

  return (
    <CodeBlockHeader>
      {title && <CodeBlockHeaderTab file={title} />}
      {(language || label) && (
        <SegmentedControl
          name={uuid.current}
          label="Select code block language"
          hideLabel
          disabled
          value={0}
          options={[{ label: language || label || '', value: 0 }]}
          onChange={handleChange}
        />
      )}
    </CodeBlockHeader>
  );
};
